export const SERVICES_LINKS = [
  {
    text: 'TV program',
    location: 'http://tvprogram.centrum.cz/'
  },
  {
    text: 'Reality',
    location: 'https://realitymix.cz/'
  },
  {
    text: 'Firmy',
    location: 'http://najisto.centrum.cz/'
  },
  {
    text: 'Práce',
    location: 'http://prace.centrum.cz/',
    redirectPattern: 'SAS'
  },
  {
    text: 'Hry',
    location: 'http://gamescafe.centrum.cz/'
  }
]
